import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { CerebroTextButton } from '../../../shared/components';
import { useApi } from '../../../shared/context';
import { QueryKeys } from '../../../shared/hooks';
import { CerebroApiEndpoints } from '../../../shared/utils/api';
import { getResponseData } from '../../../shared/utils/axios';
import { TermSheetFinancialReporting } from '../../../shared/models';

interface ReportingDeleteDialogProps {
	dataRoomGuid: string | undefined;
	termSheetGuid: string | undefined;
	revisionGuid: string | undefined;
	reporting: TermSheetFinancialReporting | null;
	close: () => void;
}

export const ReportingDeleteDialog: React.FC<ReportingDeleteDialogProps> = ({
	dataRoomGuid,
	termSheetGuid,
	revisionGuid,
	reporting,
	close,
}) => {
	const api = useApi();
	const snackbar = useSnackbar();
	const client = useQueryClient();

	const onDeleteConfirmation = () => {
		if (reporting !== null) deleteReporting(reporting);
	};

	const { mutate: deleteReporting } = useMutation<void, unknown, TermSheetFinancialReporting>(
		reportingToDelete =>
			getResponseData(
				api.delete<void>(
					CerebroApiEndpoints.TermSheets.ReportingSpecific(
						dataRoomGuid,
						termSheetGuid,
						revisionGuid,
						reportingToDelete.guid
					)
				)
			),
		{
			onMutate: () => {
				close();
			},
			onSuccess: () => {
				client.invalidateQueries(QueryKeys.TermSheets.Revision(dataRoomGuid, termSheetGuid, revisionGuid));
				snackbar.enqueueSnackbar('Reporting Deleted.', { variant: 'success' });
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem deleting the reporting.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={reporting !== null} onClose={close}>
			<DialogTitle>Confirm Delete Reporting</DialogTitle>
			<DialogContent>
				<DialogContentText>Are you sure you want to delete?</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onDeleteConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
